"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Status = void 0;

var _styles = require("./styles");

var _jsxRuntime = require("react/jsx-runtime");

var Status = function Status(_ref) {
  var statusType = _ref.statusType,
      ovalForm = _ref.ovalForm;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Container, {
    className: "status-".concat(statusType === null || statusType === void 0 ? void 0 : statusType.replace(/\/.*/, ""), " ").concat(ovalForm && "oval-form"),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      children: statusType !== null && statusType !== void 0 ? statusType : "NS"
    })
  });
};

exports.Status = Status;